"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usProvinces = exports.canadianProvinces = void 0;
exports.canadianProvinces = new Set([
    { text: 'Alberta', value: 'Alberta' },
    { text: 'British Columbia', value: 'British Columbia' },
    { text: 'Manitoba', value: 'Manitoba' },
    { text: 'New Brunswick', value: 'New Brunswick' },
    { text: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador' },
    { text: 'Northwest Territories', value: 'Northwest Territories' },
    { text: 'Nova Scotia', value: 'Nova Scotia' },
    { text: 'Nunavut', value: 'Nunavut' },
    { text: 'Ontario', value: 'Ontario' },
    { text: 'Prince Edward Island', value: 'Prince Edward Island' },
    { text: 'Quebec', value: 'Quebec' },
    { text: 'Saskatchewan', value: 'Saskatchewan' },
    { text: 'Yukon Territory', value: 'Yukon Territory' },
]);
exports.usProvinces = new Set([
    { value: 'Alaska', text: 'Alaska' },
    { value: 'Alabama', text: 'Alabama' },
    { value: 'Arkansas', text: 'Arkansas' },
    { value: 'American Samoa', text: 'American Samoa' },
    { value: 'Arizona', text: 'Arizona' },
    { value: 'California', text: 'California' },
    { value: 'Colorado', text: 'Colorado' },
    { value: 'Connecticut', text: 'Connecticut' },
    { value: 'District of Columbia', text: 'District of Columbia' },
    { value: 'Delaware', text: 'Delaware' },
    { value: 'Florida', text: 'Florida' },
    { value: 'Georgia', text: 'Georgia' },
    { value: 'Guam', text: 'Guam' },
    { value: 'Hawaii', text: 'Hawaii' },
    { value: 'Iowa', text: 'Iowa' },
    { value: 'Idaho', text: 'Idaho' },
    { value: 'Illinois', text: 'Illinois' },
    { value: 'Indiana', text: 'Indiana' },
    { value: 'Kansas', text: 'Kansas' },
    { value: 'Kentucky', text: 'Kentucky' },
    { value: 'Louisiana', text: 'Louisiana' },
    { value: 'Massachusetts', text: 'Massachusetts' },
    { value: 'Maryland', text: 'Maryland' },
    { value: 'Maine', text: 'Maine' },
    { value: 'Michigan', text: 'Michigan' },
    { value: 'Minnesota', text: 'Minnesota' },
    { value: 'Missouri', text: 'Missouri' },
    { value: 'Mississippi', text: 'Mississippi' },
    { value: 'Montana', text: 'Montana' },
    { value: 'North Carolina', text: 'North Carolina' },
    { value: 'North Dakota', text: 'North Dakota' },
    { value: 'Nebraska', text: 'Nebraska' },
    { value: 'New Hampshire', text: 'New Hampshire' },
    { value: 'New Jersey', text: 'New Jersey' },
    { value: 'New Mexico', text: 'New Mexico' },
    { value: 'Nevada', text: 'Nevada' },
    { value: 'New York', text: 'New York' },
    { value: 'Ohio', text: 'Ohio' },
    { value: 'Oklahoma', text: 'Oklahoma' },
    { value: 'Oregon', text: 'Oregon' },
    { value: 'Pennsylvania', text: 'Pennsylvania' },
    { value: 'Puerto Rico', text: 'Puerto Rico' },
    { value: 'Rhode Island', text: 'Rhode Island' },
    { value: 'South Carolina', text: 'South Carolina' },
    { value: 'South Dakota', text: 'South Dakota' },
    { value: 'Tennessee', text: 'Tennessee' },
    { value: 'Texas', text: 'Texas' },
    { value: 'Utah', text: 'Utah' },
    { value: 'Virginia', text: 'Virginia' },
    { value: 'Virgin Islands', text: 'Virgin Islands' },
    { value: 'Vermont', text: 'Vermont' },
    { value: 'Washington', text: 'Washington' },
    { value: 'Wisconsin', text: 'Wisconsin' },
    { value: 'West Virginia', text: 'West Virginia' },
    { value: 'Wyomin', text: 'Wyoming' },
]);
